import { render, staticRenderFns } from "./VlanComponent.vue?vue&type=template&id=49ed7bcb&scoped=true&"
import script from "./VlanComponent.vue?vue&type=script&lang=js&"
export * from "./VlanComponent.vue?vue&type=script&lang=js&"
import style0 from "./VlanComponent.vue?vue&type=style&index=0&id=49ed7bcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed7bcb",
  null
  
)

export default component.exports